export default __webpack_public_path__ + "static/media/upload-btn-icon.10849f67.svg";